import ReportContentFromPreview from './ReportContentFromPreview';
import ProficiencyLineChart from './ProficiencyLineChart';
import WelcomeMessageModal from './WelcomeMessageModal';
import ReportContentModal from './ReportContentModal';
import AiScoreGuideModal from './AiScoreGuideModal';
import DummyPageSummary from './DummyPageSummary';
import PageLibraryModal from './PageLibraryModal';
import AutosizeTextarea from './AutosizeTextarea';
import DummyDetailCard from './DummyDetailCard';
import ScrollAppHeader from './ScrollAppHeader';
import MoreBtnDropdown from './MoreBtnDropdown';
import InProgressBadge from './InProgressBadge';
import FloatingDropup from './FloatingDropup';
import CardTitleInput from './CardTitleInput';
import DateTimePicker from './DateTimePicker';
import BasicLineGauge from './BasicLineGauge';
import FinishedBadge from './FinishedBadge';
import LoadingBounce from './LoadingBounce';
import DummyPageItem from './DummyPageItem';
import EditorToolbar from './EditorToolbar';
import ImageCarousel from './ImageCarousel';
import FooterContent from './FooterContent';
import IconDropdown from './IconDropdown';
import ToggleSwitch from './ToggleSwitch';
import CardPreview from './CardPreview';
import SearchInput from './SearchInput';
import TopicDropup from './TopicDropup';
import PolicyModal from './PolicyModal';
import CustomModal from './CustomModal';
import UpDownArrow from './UpDownArrow';
import MainLayout from './MainLayout';
import BasicModal from './BasicModal';
import BaseEditor from './BaseEditor';
import AppHeader from './AppHeader';
import AppFooter from './AppFooter';
import TableCard from './TableCard';
import DummyCard from './DummyCard';
import PageItem from './PageItem';
import Checkbox from './Checkbox';
import Snackbar from './Snackbar';
import LcAudio from './LcAudio';
import LcImage from './LcImage';
import LcVideo from './LcVideo';
import Tooltip from './Tooltip';
import AppMain from './AppMain';
import Radio from './Radio';
import Card from './Card';
import ProgressBar from './ProgressBar';
import LineGauge from './LineGauge';

export const components = {
  ReportContentFromPreview,
  ProficiencyLineChart,
  WelcomeMessageModal,
  ReportContentModal,
  AiScoreGuideModal,
  DummyPageSummary,
  PageLibraryModal,
  AutosizeTextarea,
  DummyDetailCard,
  ScrollAppHeader,
  MoreBtnDropdown,
  InProgressBadge,
  FloatingDropup,
  CardTitleInput,
  DateTimePicker,
  BasicLineGauge,
  FinishedBadge,
  EditorToolbar,
  ImageCarousel,
  FooterContent,
  LoadingBounce,
  DummyPageItem,
  ToggleSwitch,
  IconDropdown,
  CardPreview,
  SearchInput,
  TopicDropup,
  PolicyModal,
  CustomModal,
  UpDownArrow,
  MainLayout,
  BasicModal,
  BaseEditor,
  AppHeader,
  AppFooter,
  TableCard,
  DummyCard,
  PageItem,
  Checkbox,
  Snackbar,
  LcAudio,
  LcImage,
  LcVideo,
  Tooltip,
  AppMain,
  Radio,
  Card,
  ProgressBar,
  LineGauge,
};

export default function install(Vue) {
  Object.keys(components).forEach((name) => {
    Vue.component(name, components[name]);
  });
}



// WEBPACK FOOTER //
// ./src/components/index.js